export const enum ContextMenuTypes {
  EXPLORER = "EXPLORER",
  EXPLORER_ITEMS = "EXPLORER_ITEMS",
  EXPLORER_ITEM = "EXPLORER_ITEM",
  TRACK = "TRACK",
  TRACK_LIKE = "TRACK_LIKE",
  TAG = "TAG",
  PLAYLIST = "PLAYLIST",
  WAVEFORM = "WAVEFORM",
  WAVEFORM_SEGMENT = "WAVEFORM_SEGMENT",
  WAVEFORM_POINT = "WAVEFORM_POINT",
  TABLE_ROW_SEGMENT = "TABLE_ROW_SEGMENT",
  TABLE_ROW_POINT = "TABLE_ROW_POINT",
  EXPLORER_TREE_ITEM = "EXPLORER_TREE_ITEM",
}
